import { ColonistMembershipType } from '@colonist/types';
import { MembershipIncentiveEndgameDialog } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../../ui_platform/mountDialogUIReactComponent.tsx';
import { ColonistMembershipProduct } from '../../../../../shared/store/ColonistMembershipProduct.ts';
import { navigateToPage } from '../../ui_utils/ClientUtils.ts';
import { uiManagerEvents } from '../../EntryShared.ts';
import { isSubscriptionOverlayVariant } from '../../store/subscription_overlay/subscriptionOverlayABTest.ts';
import { CA } from '../../analytics/Analytics.ts';
import { AnalyticEventCategory, AnalyticEventType, AnalyticEventValue } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { StorageWrapper } from '../../StorageWrapper.ts';
const renderMembershipIncentiveEndgameDialog = mountDialogUIReactComponent(MembershipIncentiveEndgameDialog);
export function showMembershipIncentiveEndgameDialog(continuationAction, continuationText) {
    const { price, isLocalizedPrice } = getPremiumMonthlyPriceDisplay();
    let isOpeningSubscriptionOverlay = false;
    renderMembershipIncentiveEndgameDialog({
        continuationText: continuationText,
        price: price,
        isLocalizedPrice: isLocalizedPrice,
        onBecomeMember: ()=>{
            sendMembershipIncentiveEndgameAnalytic();
            if (isSubscriptionOverlayVariant()) {
                isOpeningSubscriptionOverlay = true;
                uiManagerEvents.premiumMembershipCheckAction();
                return;
            }
            navigateToPage('/store#membership', true);
        },
        onContinue: ()=>{
            if (isOpeningSubscriptionOverlay) return;
            continuationAction();
        }
    });
}
function getPremiumMonthlyPriceDisplay() {
    const product = ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.PremiumMonthly);
    const localizedSubscription = StorageWrapper.getLocalizedStoreSubscriptionData().find((data)=>data.subscriptionId == product.mobileIAPSKUId);
    if ((localizedSubscription === null || localizedSubscription === void 0 ? void 0 : localizedSubscription.price) != null && localizedSubscription.displayPrice != '') {
        return {
            price: localizedSubscription.displayPrice,
            isLocalizedPrice: true
        };
    }
    return {
        price: product.getDefaultPrice(),
        isLocalizedPrice: false
    };
}
function sendMembershipIncentiveEndgameAnalytic() {
    const eventData = {
        type: AnalyticEventType.ABTestClickAnalytics,
        category: AnalyticEventCategory.ABTestClickAnalytics,
        floatValue: AnalyticEventValue.PopupMembershipIncentiveEndgame
    };
    void CA.sendAnalyticEvent(eventData);
}
